// extracted by mini-css-extract-plugin
module.exports = {"localLink":"LocalLink_localLink__1A8n-"};